import React, { ReactNode } from 'react';
import { 
  StyleSheet, 
  View, 
  StyleProp,
  ViewStyle 
} from 'react-native';
import { Colors } from '../../themes/colors';

export interface MessageBubbleProps {
  containerStyle?: StyleProp<ViewStyle>;
  children: ReactNode;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({
  containerStyle,
  children
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.card}>
        <View style={styles.tail} />
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: 400,
  },
  card: {
    backgroundColor: Colors.role.surface,
    width: '80%',
    marginTop: 100,
    borderRadius: 20,
    padding: 30,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 4,
      height: 4,
    },
    shadowOpacity: 1,
    shadowRadius: 50,
    elevation: 1,
    position: 'relative',
  },
  tail: {
    position: 'absolute',
    bottom: -15,
    marginLeft: 'auto',
    width: 30,
    height: 30,
    backgroundColor: Colors.role.surface,
    transform: [{ rotate: '45deg' }],
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: Colors.role.borderSection,
    borderTopWidth: 0,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors.role.textPrimary,
    textAlign: 'center',
  },
  description: {
    fontSize: 14,
    color: Colors.role.textSecondary,
    textAlign: 'center',
    lineHeight: 18,
  },
  dividerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: Colors.role.borderControl,
  },
  orText: {
    fontSize: 12,
    color: Colors.role.fillMuted,
    marginHorizontal: 15,
  },
  subscriptionContainer: {
    alignItems: 'center',
  },
  subscriptionText: {
    fontSize: 14,
    color: Colors.role.textSecondary,
    textAlign: 'center',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  hereLink: {
    fontSize: 14,
    color: '#3b82f6',
  },
});
